import { createContext } from 'react';

import type { SupportDrawerContextValue } from '../types';

// ----------------------------------------------------------------------

export const SupportDrawerContext = createContext<SupportDrawerContextValue | undefined>(undefined);
